import {useCallback, useState} from 'react';

export interface SwitchType {
  isOn: boolean;
  turnOff: () => void;
  turnOn: () => void;
  toggle: () => void;
}

export const useSwitch = (defaultState = false): SwitchType => {
  const [isOn, setIsOn] = useState(defaultState);
  const turnOff = useCallback(() => {
    setIsOn(false);
  }, []);
  const turnOn = useCallback(() => {
    setIsOn(true);
  }, []);
  const toggle = useCallback(() => {
    setIsOn((prevState) => !prevState);
  }, []);
  return {
    isOn,
    turnOn,
    turnOff,
    toggle,
  };
};
